import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faYoutube } from '@fortawesome/free-brands-svg-icons'
import { faBars, faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueSmoothScroll from 'vue3-smooth-scroll'

library.add([faYoutube, faBars, faXmark])

import "@/assets/styles/main.css";

createApp(App)
    .use(router)
    .use(VueSmoothScroll)
    .component('font-awesome-icon', FontAwesomeIcon)
        .mount('#app')
